import React, { FunctionComponent } from 'react';

import { PageContainer } from 'containers/page/page-container';
import { BFFComingSoonHeroBlockContainer } from 'containers/project-love/about/bff-coming-soon-hero-block-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

export const BFFComingSoonContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer activeMenu="friends" />
      <main id="main" tabIndex={-1}>
        <div className="bff-coming-soon-hero-block">
          <BFFComingSoonHeroBlockContainer />
        </div>
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
